import React, { useEffect, useState } from 'react';
import images from '../images';
import styles from '../css/Categorias.module.scss'

export const Contador = ({ texto, numero, esPrimero }) => {
    
    const [contador, setContador] = useState(false);
    
    useEffect(() => {
        function animateNumber(target, duration) {
            let start = 0; // Valor inicial
            const end = target; // Valor final
            const startTime = performance.now(); // Tiempo de inicio

            function update() {
                const elapsed = performance.now() - startTime;
                const progress = Math.min(elapsed / duration, 1);
                const currentValue = Math.floor(progress * end);
                const formattedValue = currentValue.toLocaleString();
                setContador(formattedValue);
                if (progress < 1) {
                    requestAnimationFrame(update);
                }
            }

            update();
        }

        animateNumber(numero, 2000);

    }, [])
    return (
        <>
            <div className={'d-inline-block ' + (esPrimero? '' : 'ms-3 ps-3 border-start border-white')}>
                <h2>{'+' + contador}</h2>
                <p className='mb-0'>{texto}</p>
            </div>
        </>
    )

}